import { Box, CardMedia, Grid, Stack, Typography } from "@mui/material";
import { briefInfoType, userState } from "../../interface/MainInterface";
import "./CardBriefDetail.css";
import { useEffect, useRef, useState } from "react";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { useWindowSize } from "../../utils/useWindowSize";

interface propsType {
  userState: userState;
  scrapInfo: any;
  briefInfo: briefInfoType;
  callback: any;
}

const unAuthAPI = new HttpUnAuthApi();

const CardBriefDetail = (props: propsType) => {
  const windowSize = useWindowSize();

  const delete_scrap = async () => {
    // 먼저 confirm을 처리하고, 이후에 비동기 코드 실행 (iOS 18.6.2 버전에서 동작하지 않아서 confirmed 처리)
    const confirmed = window.confirm("선택하신 브리프를 스크랩보드에서 삭제하시겠습니까?");
    if (!confirmed) return;

    let info = props.scrapInfo;
    let temp: any = [];
    for (const key of props.scrapInfo?.scrap_key_list) {
      if (props.briefInfo.show_pk === key.show_pk && props.briefInfo.sk === key.sk && props.briefInfo.keyword === key.keyword) {
        continue;
      } else {
        temp.push(key);
      }
    }
    info.scrap_key_list = temp;

    let keys: any = [];
    for (const key of info.scrap_key_list) {
      if (keys.indexOf(key['keyword']) < 0) {
        keys.push(key['keyword']);
      }
    }

    // const idx = temp.indexOf(`${props.briefInfo.pk}/${props.briefInfo.sk}`);
    // temp.splice(idx, 1);

    // info.scrap_key_list = temp;

    // let keys: any = [...info.selectedKeywords];
    // const kidx = keys.indexOf()

    const param: any = {
      command: "update_scrap_info2",
      scrap_info: props.scrapInfo,
      selectedKeywords: keys,
      user_id: props.userState.id,
    };

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      props.callback({ command: "delete_brief" });
    } else {
      console.error("res : ", res);
    }
  };
  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
        <Box sx={{ marginBottom: "17px" }}>
          <Stack direction={"column"} spacing={0}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "143px",
                borderRadius: "20px",
                backgroundColor: "rgba(232, 232, 232, 1)",
                cursor: "pointer",
              }}
              onClick={() => {
                window.open(`/brief/${props.briefInfo.show_pk}/${props.briefInfo.sk}`);
              }}
            >
            {props.briefInfo.image_list[0] ?
              <CardMedia
                component={"img"}
                image={props.briefInfo.image_list[0]}
                sx={{ height: "143px", borderRadius: "16px" }}
                onError={(e) => {
                  e.currentTarget.src = "/images/no-image.png";
                  e.currentTarget.className = "noImage";
                }}
              />
              :
              <img className="noImage" src="/images/no-image.png" />
            }
            </Box>

            <Box sx={{ p: "14px" }}>
              <Typography className="line-clamp2" sx={{ fontSize: "16px", fontWeight: "800" }}>
                {props.briefInfo.ai_title}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Box className="btn-delete" sx={{ cursor: "pointer", display: "flex" }}>
                <CardMedia
                  className="btn-delete-img"
                  component={"img"}
                  image="/images/svg-delete.svg"
                  sx={{ height: "18px", width: "18px" }}
                  onClick={delete_scrap}
                />
                {windowSize.width > 1023 && (
                  <Typography
                    className="btn-delete-text"
                    sx={{
                      fontSize: windowSize.width > 1023 ? "16px" : "13px",
                      fontWeight: "500",
                      lineHeight: windowSize.width > 1023 ? "19px" : "16.9px",
                      color: "rgba(138, 138, 138, 1)",
                    }}
                    onClick={delete_scrap}
                  >
                    {"삭제"}
                  </Typography>
                )}
              </Box>
            </Box>
          </Stack>
        </Box>
      </Grid>
    </>
  );
};

export default CardBriefDetail;
